import { Routes } from '@angular/router';

import { candidateAuthGuard, signedOutGuard } from './core/auth.guard';

/**
 * The candidate account's routes (docs/10 2.3 + 4c/4d): the auth pair, the cross-tenant
 * dashboard, one application's conversation view, the profile and the rights hub. All
 * lazy-loaded; titles are Danish defaults (the surface language switches at runtime, the
 * document title follows the route entry point). Signed-in-only routes carry the guard.
 *
 * `/login` and `/register` sit at the top level (their own standalone layout, no shell); every
 * authenticated route hangs off the routed `ShellComponent` layout so the top bar, nav and
 * footer render only around the signed-in surfaces.
 */
export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login-page').then((m) => m.LoginPage),
    title: 'Log ind',
    canActivate: [signedOutGuard],
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register-page').then((m) => m.RegisterPage),
    title: 'Opret konto',
    canActivate: [signedOutGuard],
  },
  {
    path: '',
    loadComponent: () => import('./shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/dashboard/dashboard-page').then((m) => m.DashboardPage),
        title: 'Mine ansøgninger',
        canActivate: [candidateAuthGuard],
      },
      {
        path: 'ansoegning/:id',
        loadComponent: () =>
          import('./pages/application/application-page').then((m) => m.ApplicationPage),
        title: 'Min ansøgning',
        canActivate: [candidateAuthGuard],
      },
      {
        path: 'min-profil',
        loadComponent: () => import('./pages/profile/profile-page').then((m) => m.ProfilePage),
        title: 'Min profil',
        canActivate: [candidateAuthGuard],
      },
      {
        path: 'mine-rettigheder',
        loadComponent: () => import('./pages/rights/rights-page').then((m) => m.RightsPage),
        title: 'Mine rettigheder',
        canActivate: [candidateAuthGuard],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];